<template>
  <div v-if="!pending" class="tailwind">
    <PartnerRedirectButtons :partner-redirect-config="partnerRedirectConfig" :customer="customer" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { startUpLabels } from './composables/useLabels.js'
import { PartnerRedirectButtons } from '@common/lib-vue-common'

const pending = ref(true)
const customer = ref({})
const partnerRedirectConfig = ref({
  linkNonLoggedUsers: {
    title: '',
    url: ''
  },
  linkLoggedUsers: {
    title: '',
    url: ''
  }
})

const loadLabels = async () => {
  try {
    await startUpLabels()
    pending.value = false
  } catch (error) {
    console.error('Error loading labels:', error)
  }
}

onMounted(() => {
  loadLabels()

  if (window?.vdxProps) {
    partnerRedirectConfig.value = window.vdxProps
  }

  $(window).on('auth.logged auth.postlogged', function (event, data) {
    customer.value = data
  })

  $(window).on('auth.nologged', function () {
    customer.value = {}
  })
})
</script>
